// India-app date helpers. Using UTC slices (toISOString) for "today"/"this
// month" defaults is wrong in early-morning IST (it can show the previous
// day/month). These derive the value from the Asia/Kolkata calendar date.

const IST = 'Asia/Kolkata'

/** Current IST calendar date as YYYY-MM-DD. */
export const istDate = (): string =>
  new Date().toLocaleDateString('en-CA', { timeZone: IST })

/** Current IST month as YYYY-MM. */
export const istMonth = (): string => istDate().slice(0, 7)

/** Tomorrow's IST calendar date as YYYY-MM-DD. */
export const istTomorrow = (): string => {
  const now = new Date()
  const todayIst = new Date(now.toLocaleString('en-US', { timeZone: IST }))
  todayIst.setDate(todayIst.getDate() + 1)
  return todayIst.toLocaleDateString('en-CA')
}
